// Available days + slots for the booking widget.
// Mon–Sat, 9 AM – 3 PM, in 2-hour slots. Last appointment starts at 1 PM.
export const TIME_SLOTS = [
  "9:00 AM - 11:00 AM",
  "11:00 AM - 1:00 PM",
  "1:00 PM - 3:00 PM",
];

// Backwards-compatible alias (older code referenced SATURDAY_SLOTS)
export const SATURDAY_SLOTS = TIME_SLOTS;

export function formatISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function formatFriendly(d) {
  return d.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
}

// Returns the next `count` working days (Mon–Sat) starting tomorrow.
export function getUpcomingWorkDays(count = 12) {
  const result = [];
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 1); // start from tomorrow
  while (result.length < count) {
    if (d.getDay() !== 0) {
      result.push(new Date(d));
    }
    d.setDate(d.getDate() + 1);
  }
  return result;
}

// Backwards-compat alias
export const getUpcomingSaturdays = getUpcomingWorkDays;
